import baseAxios from "../../../../services/baseAxios"
import { EnumEndpoints } from "@/constants/app/type"
import { EnumAPIKey } from "@/constants/app/api"

export const getAirportsService = async () => {
  let res = await baseAxios(EnumAPIKey.API_BASE).get(EnumEndpoints.GET_AIRPORTS, {
      params: {
        query: "A"
      }
    })
  return res
}